import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ThemedViewAllLink(props) {
  const config = useThemeConfig();
  const ThemedViewAllLink = config.components.ViewAllLink;

  return <ThemedViewAllLink {...props} />;
}
